import * as acadieContent from "./products/acadie/content";
import * as blackwaveContent from "./products/blackwave/content";
import { buildBoxContents } from "./productBuilder";

export default function getProducts(isMobile) {
  return {
    ACADIE: {
      ...acadieContent.info,
      boxContents: buildBoxContents(acadieContent, isMobile),
    },
    BLACKWAVE: {
      ...blackwaveContent.info,
      boxContents: buildBoxContents(blackwaveContent, isMobile),
    }
  };
}
